import React from 'react';
import { Typography } from 'fronton-react';
import { Container, ModalContainer } from 'common/components';
import { PopularCategoriesSection, PopularCategoriesSlider } from './components';
import { PopularCategoryModal } from './components/popular-categories-modal';
import { usePopularCategories } from './hooks';

export const PopularCategories = () => {
	const { onCloseModalHandler, isModalOpen, modalData, isSmallScreen } = usePopularCategories();

	return (
		<PopularCategoriesSection>
			<Container>
				<Typography variant={isSmallScreen ? 'h3' : 'h2'} as="h2">
					Популярные услуги
				</Typography>
				<PopularCategoriesSlider />
				<ModalContainer
					onClose={onCloseModalHandler}
					isOpen={isModalOpen}
					variant="curtain"
				>
					<PopularCategoryModal categoryData={modalData} />
				</ModalContainer>
			</Container>
		</PopularCategoriesSection>
	);
};
